import { render, staticRenderFns } from "./Evaluation_statistics.vue?vue&type=template&id=044bdc1f&style=height%3A%20100%25%3B"
import script from "./Evaluation_statistics.vue?vue&type=script&lang=js"
export * from "./Evaluation_statistics.vue?vue&type=script&lang=js"
import style0 from "./Evaluation_statistics.vue?vue&type=style&index=0&id=044bdc1f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports